import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeartPulse,faUserShield,faCreditCard,faPiggyBank,faMoneyBillTrendUp,faChartLine,faFileContract,faBriefcase,faLandmark,
} from "@fortawesome/free-solid-svg-icons";

const features = [
  {
    icon: faUserShield,
    title: "Life Insurance",
    desc: "Pays a lump sum to beneficiaries upon the policyholder's death, ensuring financial protection",
    bgColor: "from-blue-400 to-[#124076bf]",
  },
  {
    icon: faHeartPulse,
    title: "Health Insurance",
    desc: "Covers medical expenses and hospital visits. It helps reduce healthcare costs and stress",
    bgColor: "from-blue-400 to-[#124076bf]",
  },
  {
    icon: faChartLine,
    title: "Mutual Funds",
    desc: "Mutual funds pool investor money to invest in diversified assets, offering growth and risk management.",
    bgColor: "from-blue-400 to-[#124076bf]",
  },
  {
    icon: faLandmark,
    title: "Fixed Deposit",
    desc: "Fixed deposits offer guaranteed returns with low risk, ideal for secure savings and steady growth.",
    bgColor: "from-blue-400 to-[#124076bf]",
  },
];

const FeaturedItem = ({ feature }) => {
  return (
    <div className={`bg-gradient-to-r ${feature.bgColor} text-white p-4 mt-6 shadow-2xl shadow-slate-300 min-h-[300px]`}>
      <div className="py-6 lg:p-8 xl:p-4">
        <div className="text-[30px] mb-4">
          <FontAwesomeIcon icon={feature.icon} />
        </div>
        <h4
          className="text-[22px] font-medium mb-4 ">
            {feature.title}</h4>
        <p className="text-xl opacity-80">{feature.desc}</p>
      </div>
    </div>
  );
};

FeaturedItem.propTypes = {
  feature: PropTypes.object.isRequired,
};

const Services = () => {
  return (
    <section className="py-10 md:py-10 bg-white text-zinc-900 relative overflow-hidden z-10">
      <div className="max-w-7xl px-4 mx-auto">
        <div className="flex max-w-3xl justify-center text-center mx-auto">
          <div>
            <h1 className="text-3xl font-bold leading-tight md:text-[40px] mb-4 uppercase">
              Our Services
            </h1>
            <p className="text-lg opacity-80 leading-7 mb-12">
            Effective financial management is key to long-term stability, whether for retirement, major purchases, or wealth growth. Finding the right talent can be challenging, but with our recruitment services, it doesn’t have to be.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-6">
					{features.map((feature, i) => (
						<div className="col-span-12 md:col-span-6 lg:col-span-3" key={i}>
							<FeaturedItem feature={feature} />
						</div>
					))}
				</div>
      </div>
    </section>
  );
};

export default Services